import React from "react"
import classNames from "classnames"

const Checkbox = ({register, field, fieldName, fieldAttributes, input_width, label_width, errorMessage, error}) => {
  return <div className="form-group row"
              id={"form-group-" + field}
              key={"col" + field}>
    <span
      className={"col-md-" + label_width + " r-label col-form-label-sm pt-0"}>
    </span>
    <div className={"col-md-" + input_width}>
      <div className="form-group form-check">
        <input
          {...register(fieldName)}
          id={fieldName}
          type="checkbox"
          className={classNames("form-check-input", {"is-invalid": errorMessage})}
          disabled={fieldAttributes.field_modes[field] && fieldAttributes.field_modes[field] == "readonly"}
        />
          <label className="form-check-label" htmlFor={fieldName}>
            {fieldAttributes.field_titles[field] ? fieldAttributes.field_titles[field] : field}
          </label>

        {fieldAttributes.hints[field] && <small className="form-text text-muted" dangerouslySetInnerHTML={{__html: fieldAttributes.hints[field]}}/>}
        {error(errorMessage)}
      </div>
    </div>
  </div>
}

export default Checkbox